export const PIN_ITEM_WIDTH = 23;
export const PIN_ITEM_GAP = 7;
